import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { RankedCryobox } from '../../core/api/lab.types';

export const rankedCryoboxesHasErrorSelector = (state: RootState): boolean =>
  state.rankedCryoboxList.errors && state.rankedCryoboxList.errors ? true : false;

export const rankedCryoboxesIsBusySelector = (state: RootState): boolean =>
  state.rankedCryoboxList.status === StoreStatus.BUSY;

export const rankedCryoboxesResponseSelector = (state: RootState): RankedCryobox[] | null =>
  state.rankedCryoboxList.response || null;
